<div class="modal" tabindex="-1" role="dialog" id="appModal">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" translate="PurchaseDetails.cancelPurchaseDialogTitle" [translateParams]="{ value: purchase?.purchaseSetNumber }"></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="refundForm">
                    <div class="form-group">
                        <label for="reason" translate="PurchaseEdit.refundReason"></label>
                        <select id="reason" class="form-control" formControlName="reason" hznTestId="refund-reason">
                            @for (reason of refundReasons(); track $index) {
                                <option [value]="reason.value" [translate]="reason.displayKey"></option>
                            }
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="comment" translate="PurchaseEdit.refundComment"></label>
                        <input type="text" id="comment" class="form-control" formControlName="comment" hznTestId="refund-comment"/>
                    </div>
                </form>
                <span translate="PurchaseEdit.cancelPurchageDialogContent"></span>
            </div>
            <div class="modal-footer">
                <div class="d-flex justify-content-between w-100">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()" translate="PurchaseEdit.cancelPurchaseDialogClose"></button>
                    <button type="button" class="btn btn-light" data-dismiss="modal" [disabled]="refundForm.invalid" hznTestId="refund-confirm"
                            (click)="confirm()" translate="PurchaseEdit.cancelPurchaseDialogConfirm"></button>
                </div>
            </div>
        </div>
    </div>
</div>
